module.exports = __webpack_public_path__ + "static/media/product-preview.115c4dbd.png";